import { EventsEventIdLogsGetRequest } from '@nativewaves/nw-cloud-sdk/smep'
import { createRoute } from '@tanstack/react-router'

import { DashboardSkeleton } from '@shared/layouts'
import { DynamicRouteParameterWPrefix, StaticRouteParameter } from 'config/routing'
import { JSON, JSONConfig } from 'domains/Workspaces/Events/Event'
import { Dashboard } from 'domains/Workspaces/Events/Event/Dashboard'
import { ExpManifest } from 'domains/Workspaces/Events/Event/ExpManifest'
import { Overview as Monitoring } from 'domains/Workspaces/Events/Event/Monitoring'
import { Watch } from 'domains/Workspaces/Events/Event/Watch'
import { eventsRoute } from 'pages/NWPlatform/Workspaces/Workspace/Events'
import { Structure } from 'pages/NWPlatform/Workspaces/Workspace/Events/Event/Structure'

export const eventRoute = createRoute({
  getParentRoute: () => eventsRoute,
  path: DynamicRouteParameterWPrefix.EVENT_ID,
  loader: () => ({
    crumb: {
      title: null,
    },
  }),
})

export const eventLayoutRoute = createRoute({
  getParentRoute: () => eventRoute,
  id: 'eventLayout',
  component: Structure,
})

export const eventDashboardLayoutRoute = createRoute({
  getParentRoute: () => eventLayoutRoute,
  id: 'eventDashboardLayout',
  component: DashboardSkeleton,
})

export const eventDashboardRoute = createRoute({
  getParentRoute: () => eventDashboardLayoutRoute,
  path: StaticRouteParameter.DASHBOARD,
  component: Dashboard,
})

type EventAlertsSearch = Pick<
  EventsEventIdLogsGetRequest,
  'alertId' | 'alertCode' | 'types' | 'levels' | 'from' | 'to' | 'query'
>

export const eventMonitoringRoute = createRoute({
  getParentRoute: () => eventLayoutRoute,
  path: StaticRouteParameter.MONITORING,
  component: Monitoring,
  validateSearch: (search: Record<string, unknown>): EventAlertsSearch => {
    const result: Record<string, unknown> = {}

    if (search.query && typeof search.query === 'string' && !!search.query.length) {
      result.query = search.query
    }

    if (search.types && typeof search.types === 'string' && !!search.types.length) {
      result.types = search.types
    }

    if (search.levels && typeof search.levels === 'string' && !!search.levels.length) {
      result.levels = search.levels
    }

    if (search.alertId && typeof search.alertId === 'string' && !!search.alertId.length) {
      result.alertId = search.alertId
    }

    if (search.alertCode && typeof search.alertCode === 'string' && !!search.alertCode.length) {
      result.alertCode = search.alertCode
    }

    if (search.from && typeof search.from === 'number' && !isNaN(search.from)) {
      result.from = search.from
    }

    if (search.to && typeof search.to === 'number' && !isNaN(search.to)) {
      result.to = search.to
    }
    return result satisfies EventAlertsSearch
  },
})

export const eventConfigRoute = createRoute({
  getParentRoute: () => eventLayoutRoute,
  path: StaticRouteParameter.CONFIG,
  component: JSONConfig,
})

export const eventExpManifestRoute = createRoute({
  getParentRoute: () => eventLayoutRoute,
  path: StaticRouteParameter.PROGRAM,
  component: ExpManifest,
})

export const eventRawRoute = createRoute({
  getParentRoute: () => eventLayoutRoute,
  path: StaticRouteParameter.RAW,
  component: JSON,
})

export const eventWatchRoute = createRoute({
  getParentRoute: () => eventLayoutRoute,
  path: StaticRouteParameter.WATCH,
  component: Watch,
})
